"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = MessageMediaAttachmentContainer;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _layout = _interopRequireDefault(require("./layout"));

function MessageMediaAttachmentContainer(props) {
  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isDialogOpen = _useState2[0],
      setIsDialogOpen = _useState2[1];

  function onToggleDialog() {
    setIsDialogOpen(function (prev) {
      return !prev;
    });
  }

  return /*#__PURE__*/_react["default"].createElement(_layout["default"], Object.assign({}, props, {
    isDialogOpen: isDialogOpen,
    onToggleDialog: onToggleDialog
  }));
}